/*
 * @name:  
 * @description:  
 * @Author: Han bei 
 * @Date: 2018-10-15 15:46:36 
 * @Last Modified by: Bei.HanBeiBei
 * @Last Modified time: 2020-07-27 14:00:53
 *  
 *  text  value值
 *  index 索引
 *  type  需要组件类型   text、number、percent、input、inputNumber、inputPercent 不传值默认不显示文本
 *  name  行名称
 *  title 表头
 *  record 行数据 Object
 *  totolIndex  汇总的行、需要颜色区分
 *  sqlName  数据库名称 自定义表格需要
 *  onChange 利用父级函数更新数据
 */




import React, { Component } from 'react';
import Compared from "./Compared";
import { InputNumber, Input, Tooltip } from 'antd';

const { TextArea } = Input;

class TableText extends Component {
    render() {
        const { text = '', index, type, name, onChange, totalIndex = [], warn, yellowText = "", minRows = 4 } = this.props.data;
        const { title = [], record = {}, sqlName = "", t_type = "" } = this.props.data.compared || {};
        switch (type) {
            case 'input':
                if (this.props.data.compared) {
                    return (
                        <Compared data={{ index, t_type, key: name, title, sqlName, name: record.name, type: "text" }} >
                            <div className="table-padding table-color-number">
                                <Input
                                    className="table_numInput"
                                    defaultValue={text}
                                    onBlur={(e) => {
                                        let value = e.target.value || "";
                                        onChange(name, value, index)
                                    }}
                                />
                            </div>
                        </Compared>
                    )
                }
                return (
                    <div className="table-padding table-color-number">
                        <Input
                            className="table_numInput"
                            defaultValue={text}
                            onBlur={(e) => {
                                let value = e.target.value || "";
                                onChange(name, value, index)
                            }}
                        />
                    </div>
                )
                break;
            case 'textArea':
                return (
                    <div className="table-padding table-color-number">
                        <TextArea
                            autosize={{ minRows }}
                            // className="table_numInput"
                            defaultValue={text}
                            onBlur={(e) => {
                                let value = e.target.value || "";
                                onChange(name, value, index)
                            }}
                        />
                    </div>
                )
                break;
            case 'number':
                if (this.props.data.compared) {
                    if (warn) {
                        return (
                            <Compared data={{ index, key: name, title, sqlName, name: record.name, t_type, type: "number" }} >
                                <Tooltip title={yellowText}>
                                    <div className={
                                        `table-padding
                                          heightAuto 
                                          heightAutoNum 
                                          ${totalIndex.includes(index) ? 'table-color-footer' : ''} 
                                          ${warn ? "table-text-warn" : ""} 
                                          ${yellowText && "yellowWaring"}
                                          `} >
                                        <div style={{ color: "red" }}>
                                            {Math.abs(Number(text || "0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                        </div>
                                    </div>
                                </Tooltip>
                            </Compared >
                        )
                    }
                    return (
                        <Compared data={{ index, key: name, title, sqlName, name: record.name, t_type, type: "number" }} >
                            <Tooltip title={yellowText}>
                                <div className={`table-padding heightAuto heightAutoNum ${totalIndex.includes(index) ? 'table-color-footer' : ''} 
                                  ${yellowText && "yellowWaring"}
                                `} >
                                    <div>
                                        {Number(text || '0') < 0 ?
                                            <span style={{ color: "red" }}>
                                                ({Math.abs(Number(text || "0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')})
                                            </span>
                                            :
                                            Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                        }
                                    </div>
                                </div>
                            </Tooltip>
                        </Compared >
                    )
                }

                if (warn) {
                    return (
                        <Tooltip title={yellowText}>
                            <div className={`table-padding heightAuto heightAutoNum ${totalIndex.includes(index) ? 'table-color-footer' : ''} ${warn ? "table-text-warn" : ""}  
                             ${yellowText && "yellowWaring"}
                            `} >
                                <div style={{ color: "red" }}>
                                    {Math.abs(Number(text || "0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                </div>
                            </div>
                        </Tooltip>
                    )
                }
                return (
                    <Tooltip title={yellowText}>
                        <div className={`table-padding heightAuto heightAutoNum ${totalIndex.includes(index) ? 'table-color-footer' : ''} 
                         ${yellowText && "yellowWaring"}
                        `} >
                            <div>
                                {Number(text || '0') < 0 ?
                                    <span style={{ color: "red" }}>
                                        ({Math.abs(Number(text || "0")).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')})
                                    </span>
                                    :
                                    Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                                }
                            </div>
                        </div>
                    </Tooltip>
                )
                break;
            case 'inputPercent':
                if (this.props.data.compared) {
                    return (
                        <Compared data={{ index, key: name, title, sqlName, name: record.name, t_type, type: "percent" }} >
                            <div className="table-padding table-color-number">
                                <InputNumber
                                    defaultValue={Number(text || "0") * 100 || ""}
                                    className="table_numInput"
                                    precision={1}
                                    formatter={value => `${value}%`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    parser={value => {
                                        let parseValue = value;
                                        parseValue = value.replace('%', '').replace(/\$\s?|(,*)/g, '')
                                        return parseValue
                                    }}
                                    onBlur={(e) => {
                                        let value = Number(e.target.value.replace(/%|,/g, '') || '0');
                                        value = Number(value.toFixed(1) / 100).toFixed(3);
                                        onChange(name, value, index)
                                    }}
                                />
                            </div>
                        </Compared >
                    )
                } else {
                    return (
                        <div className="table-padding table-color-number">
                            <InputNumber
                                defaultValue={Number(text || "0") * 100 || ""}
                                className="table_numInput"
                                precision={1}
                                formatter={value => `${value}%`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => {
                                    let parseValue = value;
                                    parseValue = value.replace('%', '').replace(/\$\s?|(,*)/g, '')
                                    return parseValue
                                }}
                                onBlur={(e) => {
                                    let value = Number(e.target.value.replace(/%|,/g, '') || '0');
                                    value = Number(value.toFixed(1) / 100).toFixed(3);
                                    onChange(name, value, index)
                                }}
                            />
                        </div>
                    )
                }
                break;
            case 'inputNumber':
                if (this.props.data.compared) {
                    return (
                        <Compared data={{ index, key: name, title, sqlName, name: record.name, t_type, type: "number" }} >
                            <div className={`table-padding table-color-number ${warn ? "table-inputNumber-err" : ""}`}>
                                <InputNumber
                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                    precision={2}
                                    className="table_numInput"
                                    defaultValue={Number(text || "0") || ""}
                                    onBlur={(e) => {
                                        let value = Number(e.target.value.replace(/,/g, '') || '0');
                                        value = Number(value.toFixed(2));
                                        onChange(name, value, index)
                                    }}
                                />
                            </div>
                        </Compared >
                    )
                } else {
                    return (
                        <div className={`table-padding table-color-number ${warn ? "table-inputNumber-err" : ""}`} >
                            <InputNumber
                                formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                                parser={value => value.replace(/\$\s?|(,*)/g, '')}
                                precision={2}
                                className="table_numInput"
                                defaultValue={Number(text || "0") || ""}
                                onBlur={(e) => {
                                    let value = Number(e.target.value.replace(/,/g, '') || '0');
                                    value = Number(value.toFixed(2));
                                    onChange(name, value, index)
                                }}
                            />
                        </div>
                    )
                }
                break;
            case 'percent':
                // 百分比位数根据传值进行变动
                const num = (text.toString().split('.')[1] || "").length <= 3 ? 1 : (text.toString().split('.')[1] || "").length - 2;

                if (this.props.data.compared) {
                    return (
                        <Compared data={{ index, key: name, title, sqlName, name: record.name, t_type, type: "percent" }} >
                            <Tooltip title={yellowText}>
                                <div className={`table-padding heightAuto heightAutoNum ${totalIndex.includes(index) ? 'table-color-footer' : ''} 
                                ${yellowText && "yellowWaring"}
                                ${warn ? "table-text-warn" : ""} 
                                `}>
                                    <div>
                                        {Number(text) < 0 ? <span style={{ color: "red" }}>({((Math.abs(text) * 100).toFixed(num).toLocaleString() == "-0" ? "0" : (Math.abs(text) * 100).toFixed(num).toLocaleString()) + '%'})</span> : ((text * 100).toFixed(num).toLocaleString() == "-0" ? "0" : (text * 100).toFixed(num).toLocaleString()) + '%'}
                                    </div>
                                </div>
                            </Tooltip>
                        </Compared >
                    )
                } else {
                    return (
                        <Tooltip title={yellowText}>
                            <div className={`table-padding heightAuto heightAutoNum ${totalIndex.includes(index) ? 'table-color-footer' : ''} 
                            ${yellowText && "yellowWaring"}
                            ${warn ? "table-text-warn" : ""} 
                            `}>
                                <div>
                                    {Number(text) < 0 ? <span style={{ color: "red" }}>({((Math.abs(text) * 100).toFixed(num).toLocaleString() == "-0" ? "0" : (Math.abs(text) * 100).toFixed(num).toLocaleString()) + '%'})</span> : ((text * 100).toFixed(num).toLocaleString() == "-0" ? "0" : (text * 100).toFixed(num).toLocaleString()) + '%'}
                                </div>
                            </div>
                        </Tooltip>
                    )
                }

                break;
            case 'text':
            case 'string':
            case 'textcenter':
                if (warn) {
                    return (
                        <Tooltip title={yellowText}>
                            <div className={`table-padding heightAuto ${warn ? "table-text-warn" : ""}  
                            ${yellowText && "yellowWaring"}
                            ${type == 'textcenter' && "textcenter"}
                            `} style={{ textAlign: "left" }} >
                                <div style={{ color: "red", }} dangerouslySetInnerHTML={{ __html: text || "-" }}></div>
                            </div>
                        </Tooltip>
                    )
                }
                return (

                    <Tooltip title={yellowText}>
                        <div
                            className={`table-padding heightAuto ${totalIndex.includes(index) ? 'table-color-footer' : ''} 
                            ${yellowText && "yellowWaring"}
                            ${type == 'textcenter' && "textcenter"}
                            `}
                            style={{ whiteSpace: 'initial', textAlign: type === 'string' ? 'right' : type === 'textcenter' ? 'center' : "left" }}

                        >
                            <div dangerouslySetInnerHTML={{ __html: text || "-" }}></div>
                        </div>
                    </Tooltip>
                )
                break;

            default:
                return (
                    <Tooltip title={yellowText}>
                        <div className={`table-padding heightAuto ${totalIndex.includes(index) ? 'table-color-footer' : ''} 
                        ${yellowText && "yellowWaring"}
                        `} >
                            <div style={{ justifyContent: "flex-end" }}>-</div>
                        </div>
                    </Tooltip>
                )
                break;
        }
    }
}

export default TableText;


// WEBPACK FOOTER //
// ./src/components/table/TableText.js